import script from "./dottoriPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./dottoriPage.vue?vue&type=script&setup=true&lang=ts"

import "./dottoriPage.vue?vue&type=style&index=0&id=c7e4aca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7e4aca8"]])

export default __exports__